import { z } from "zod";

export const OBSERVATION_MAX_LENGTH = 5000;

export const observationReasonSchema = z.object({
    reason: z
        .string()
        .min(1, "La observación es obligatoria")
        .max(
            OBSERVATION_MAX_LENGTH,
            `La observación no debe superar ${OBSERVATION_MAX_LENGTH} caracteres`,
        )
        .refine((val) => {
            return val.trim().length > 0;
        }, "La observación no puede estar vacía"),
});

export type ObservationReasonFormData = z.infer<typeof observationReasonSchema>;